import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[searchUi]'
})
export class SearchUi{
  @HostBinding('class')
  elementClass = 'ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-8 ant-col-xl-6';

}
